module.exports = __webpack_public_path__ + "static/media/7m.ed8f74f4.png";